(() => {
  const params = new URLSearchParams(window.location.search);
  if (params.get('view') !== 'you-re-all-signed-up') return;

  let pending = false;
  try {
    pending = window.sessionStorage.getItem('ale_studio_newsletter_pending') === '1';
  } catch (_) {}
  if (!pending) return;

  const payload = {
    studio_version: 'v1',
    source_location: 'whats_new_page',
    form_name: 'experience_studio_whats_new',
    page_location: `${window.location.origin}${window.location.pathname}`,
    page_title: document.title || 'A Lovely Everyday'
  };

  const send = () => {
    try {
      if (window.Shopify?.analytics?.publish) {
        window.Shopify.analytics.publish('ale_studio_newsletter_signup', payload);
        return true;
      }
    } catch (_) {}
    return false;
  };

  if (!send()) window.setTimeout(send, 350);
  try { window.sessionStorage.removeItem('ale_studio_newsletter_pending'); } catch (_) {}
})();
